import React from 'react';
import styles from './AppOverlay.module.css';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { useTranslation } from 'react-i18next';


export default function AppOverlay({ loading }) {
  const { notify } = useNotifications();
  const { t } = useTranslation();
  return (
    <>
      {loading && <div className={styles.overlay}>{t('ui.loading')}</div>}
    </>
  );
}
